import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/lib/redux';

import {
  filterProductNames,
  filterUniqueMessages,
  sortRecommendations,
} from './lib';
import { AnnouncementFindPayload, Recommendation } from './types';
import { getInsightServiceUrl } from './constants';
import { getBoostEmInsights } from './query-functions';

export const insightsApi = createApi({
  reducerPath: 'insights',
  baseQuery: baseQuery(getInsightServiceUrl),
  endpoints: (builder) => ({
    getInsights: builder.query<Recommendation[], AnnouncementFindPayload>({
      query: (insightsFindPayload: AnnouncementFindPayload) => {
        return {
          url: `/announcement/find/relevant`,
          method: 'POST',
          body: insightsFindPayload,
        };
      },
      transformResponse: (response: unknown) => {
        const typedResponse = response as Recommendation[];

        let transformedResponse = typedResponse.map((item) => {
          // @TODO remove this check once there won't be any old ProductName recommendations
          if ('productName' in item.content) {
            const productNamesRecommendation = {
              ...item,
              content: {
                ...item.content,
                productNames: {
                  [item.app_product_names[0]]: item.content.productName,
                },
              },
            };

            return productNamesRecommendation as Recommendation;
          }

          const productNames = filterProductNames(
            item.content.productNames,
            item.app_product_names,
          );

          return {
            ...item,
            content: {
              ...item.content,
              productNames,
            },
          };
        });

        transformedResponse = filterUniqueMessages(transformedResponse);
        transformedResponse = sortRecommendations(transformedResponse);

        return transformedResponse;
      },
    }),
    getBoostEmRecommendations: builder.query<Recommendation[], string[]>({
      queryFn: getBoostEmInsights,
    }),
  }),
});

export const { useGetInsightsQuery, useGetBoostEmRecommendationsQuery } =
  insightsApi;
